import { useQuery } from '@tanstack/react-query';
import { getKpiEvaluationByType } from '@/api/kpi-evaluation/kpi-evaluation';
import { KpiObjectType } from '@/api/entities/kpi';

export const useGetKpiEvaluationByType = (type: KpiObjectType) => {
  return useQuery({
    queryKey: ['getKpiEvaluationByType', type],
    queryFn: () => getKpiEvaluationByType(type),
  });
};
